<template>
  <div class="sion-personnel personal-box" v-loading.fullscreen.lock="loading">
    <div class="sino-panel">
      <!--头部开始 -->
      <top-part :rightPart="true">
        <!-- 搜索框 -->
        <div class="panel-top" slot="difinePort">
          <el-input v-model="seach">
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
          <div class="search-btn" @click="search">搜索</div>
        </div>
        <!-- 搜索框结束 -->
      </top-part>
      <!-- 头部结束 -->
      <div class="panel-content my-content">
        <template>
          <div class="panel-scroll">
            <!-- 左侧科室盒子 -->
            <div class="scroll-aside">
              <div
                :class="['aside-item',item.active?'item-active':'']"
                v-for="(item,index) in officeData"
                :key="index"
                @click="selectOffice(item)"
              >
                <span class="management-name">{{item.name}}</span>
                <span>({{item.totalNum}})</span>
              </div>
            </div>
            <!-- 左侧科室盒子结束 -->
            <div class="scroll-panel" ref="scrollView">
              <!-- 选则人得盒子 -->
              <div class="item item-radio" v-if="status==1">
                <cube-radio-group>
                  <cube-radio
                    v-for="(item, index) in staffListData.slice(0,currentData)"
                    :key="index"
                    :option="item"
                    v-model="selected"
                  >
                    <div class="panel-item">
                      <div class="item item-phone">
                        <img v-if="item.photo" :src="item.photo" alt />
                        <img v-else src="@/images/doctor.png" alt srcset />
                      </div>
                      <div class="item item-info">
                        <div @click="getPersonDetail(item)">
                          <div class="info-name">{{item.name}}</div>
                          <div class="info-number">性别:{{item.sex == "2" ? "女" : "男"}}</div>
                        </div>
                        <div class="info-number" @click="callTel(item.phone)">
                          手机号:
                          <span>{{item.phone}}</span>
                        </div>
                      </div>
                    </div>
                  </cube-radio>
                </cube-radio-group>
              </div>
              <!-- 选则人得盒子结束 -->

              <div
                class="load-more mr-bottom"
                v-if="currentData<staffListData.length"
                @click="loadMore"
              >点击加载更多</div>
              <div class="load-more mr-bottom" v-else>没有更多了</div>
            </div>
          </div>
        </template>
      </div>
      <div class="sino-footer">
        <div class="footer-box transfer" @click="selectOK">确定</div>
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import { toast } from "@/common/api/api.js";
import topPart from "../../../components/topPart";
import {
  officeTreeData,
  getAppStaffListData,
  officeTransfer
} from "@/common/api";
export default {
  components: {
    topPart
  },
  data() {
    return {
      rputer: "", //需要跳转得路由地址
      allCheck: false,
      seach: "",
      loading: false,
      currentData: 20,
      officeData: [],
      activeData: [],
      staffListData: [],
      currentDepartment: "",
      unionId: JSON.parse(localStorage.getItem("loginInfo")).unionId,
      actionShow: false,
      option: {
        label: ""
      },
      status: "",
      options: {},
      selected: "",
      selectedPerson: ""
    };
  },
  watch: {
    allCheck(value) {
      this.staffListData.forEach(item => {
        if (value) item.check = true;
        else item.check = false;
      });
    },
    seach(value) {
      if (!value) {
        this.getAppStaffList(this.currentDepartment);
      }
    }
  },
  created() {
    //获取需要跳转得路由地址 并保存
    this.router = this.$route.query.router;
    this.status = this.$route.query.status ? this.$route.query.status : "";
    this.getOfficeTree();
    this.getAppStaffList();
    window.addEventListener("scroll", this.scrollBottom);
  },
  methods: {
    //点击确定事件 跳转到相对得路由 并保存存储得值
    selectOK() {
      this.staffListData.forEach(item => {
        if (item.id == this.selected) {
          this.selectedPerson = item;
          this.$router.push({
            path: this.router,
            query: {
              person: this.selectedPerson
            }
          });
        }
      });
      if (!this.selected) {
        toast(this, "请选择申请人员");
      }
    },
    getOfficeTree() {
      let loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
      let data = {
        unionId:
          loginInfo.identity == "4" || loginInfo.identity == "4"
            ? ""
            : this.unionId
      };
      officeTreeData(data).then(res => {
        if (res.code == 200) {
          res.data.forEach((item, index) => {
            if (index == 0) {
              item.active = true;
            } else {
              item.active = false;
            }
            if (loginInfo.identity == 4 || loginInfo.identity == 5) {
              if (item.level == 2 || item.level == 3) {
                this.activeData.push({
                  content: item.name,
                  id: item.id,
                  parentId: item.parentId,
                  parentName: item.parentName,
                  type: item.type
                });
              }
            } else if (loginInfo.identity == 3 || loginInfo.identity == 2) {
              if (item.level == 3) {
                this.activeData.push({
                  content: item.name,
                  id: item.id,
                  parentId: item.parentId,
                  parentName: item.parentName,
                  type: item.type
                });
              }
            }
          });
          this.officeData = res.data;
        }
      });
    },
    loadMore() {
      this.currentData += 20;
    },
    getAppStaffList(unionId, name) {
      let baseInfo = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : "";
      const params = {
        unionId: unionId ? unionId : this.unionId,
        name: name ? name : "",
        status: "0,2"
      };
      if (
        !unionId &&
        (baseInfo.identity === "4" || baseInfo.identity === "5")
      ) {
        delete params.unionId;
      }
      this.loading = true;
      getAppStaffListData(params).then(res => {
        if (res.code == 200) {
          res.data.list.forEach(item => {
            item.check = false;
            item.value = item.id;
          });
          this.staffListData = res.data.list;
        } else {
          toast(this, res.message, "error");
        }

        this.loading = false;
      });
    },
    selectOffice(item) {
      this.currentData = 20;
      this.$refs.scrollView.scrollTop = 0;
      this.officeData.forEach(item => {
        item.active = false;
      });
      item.active = true;
      this.getAppStaffList(item.id, this.seach);
      this.currentDepartment = item.id;
    },
    selectBranch(data) {
      let checkItem = [];
      this.staffListData.forEach(item => {
        if (item.check) {
          checkItem.push(item);
        }
      });
      this.$createDialog({
        title: "提示",
        type: "confirm",
        icon: "cubeic-alert",
        content: `是否将所选人员调入${data.content}?`,
        onConfirm: () => {
          this.getOfficeTransfer(data, checkItem);
          this.actionShow = false;
          document.getElementsByTagName("body")[0].setAttribute("style", "");
        }
      }).show();
    },
    close() {
      this.actionShow = false;
      document.getElementsByTagName("body")[0].setAttribute("style", "");
    },

    // 拼接
    concatStr(arr) {
      let str = "";
      arr.forEach((item, index) => {
        if (index == arr.length - 1) {
          str += item.name;
        } else {
          str += item.name + "、";
        }
      });
      return str;
    },

    getOfficeTransfer(obj, person) {
      this.loading = true;
      let params = {};
      let personArr = [];
      person.forEach(item => {
        personArr.push(item.id);
      });
      params.staffIds = personArr.join(",");
      //选择科室
      if (obj.type == 3) {
        params.importDeptId = obj.id; //科室ID
        params.importDeptName = obj.content; //科室Name
        params.importUnionId = obj.parentId; //调入工会id
        params.importUnionName = obj.parentName; //调入工会名称
      } else {
        //选择分会
        params.importUnionId = obj.id; //调入工会id
        params.importUnionName = obj.content; //调入工会名称
      }
      officeTransfer(params).then(res => {
        if (res.code == 200) {
          let duration = 0;
          let successList = res.data.list;
          let failList = res.data.errList;
          if (
            successList.length == 1 &&
            successList.length + failList.length == 1
          ) {
            duration = 3000;
          }

          let str = `<p class='title msg'>${res.message}</p>`;
          if (successList.length != 0) {
            let successPerson = this.concatStr(successList);
            str += `<div class="person-block"><i class='el-icon-success'></i><p class='msg success'>调动成功的人:<span>${successPerson}</span></p></div>`;
          }
          if (failList != 0) {
            let failPerson = this.concatStr(failList);
            str += `<div class="person-block"><i class='el-icon-error'></i><p class='fail'>调动失败的人:${failPerson}</p></div>`;
          }
          this.$message({
            type: "success",
            dangerouslyUseHTMLString: true,
            message: str,
            duration: duration,
            showClose: true,
            customClass: "person"
          });
          this.getAppStaffList(this.currentDepartment);
          this.getOfficeTree();
          this.loading = false;
        } else {
          toast(this, res.message, "error");
          this.loading = false;
        }
      });
    },
    //模糊搜索
    search() {
      if (this.seach) this.getAppStaffList(this.currentDepartment, this.seach);
    },
    callTel(tel) {
      if (!tel) return;
      let telNode = document.createElement("a");
      telNode.style.display = "none";
      telNode.href = "tel:" + tel;
      telNode.click();
    },
    getPersonDetail(option) {
      this.$router.push({
        path: "/persinnelDetail",
        query: {
          id: option.id
        }
      });
    }
  }
};
</script>
<style lang="stylus" type="stylesheet/stylus">
.personal-box {
  .panel-top {
    height: 44px;
  }

  .panel-top .el-input__icon {
    line-height: 44px;
  }

  .el-input__prefix {
    top: -5px;
  }
  .back-box {
    width: 20%;
  }
  .sino-footer {
    position: fixed;
    width: 100%;
    bottom: 0;
  }
}

.el-message--success {
  background-color: #fff !important;
  border-color: #e2e2e2 !important;
}

.el-message {
  min-width: 100px !important;
  max-width: 80%;
}

.person {
  width: 80% !important;

  .person-block {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: row;
  }

  > i.el-message, > i.el-icon-success {
    display: none;
  }

  p.title, p.success {
    color: #000 !important;
  }

  p.fail {
    color: red !important;
  }

  i {
    display: inline-block;
    margin-right: 5px;
  }

  .msg {
    margin-bottom: 10px;
  }
}

.mr-bottom {
  text-align: center;
  font-size: 14px;
  color: #38c7c4;
  padding: 10px 0;
}

.sino-footer {
  .election {
    flex: 5;

    .cube-checkbox-wrap {
      width: 40%;
    }
  }

  .transfer {
    flex: 2;
    background: rgba(56, 199, 196, 1);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);

    &:active {
      background: rgba(56, 199, 196, 0.5);
    }
  }

  .footer-box {
    height: 100%;
  }
}

.panel-top {
  height: 60px;
  background: #fff;
  display: flex;
  align-items: center;
  padding: 0 0.6rem;

  .search-btn {
    width: 40px;
    margin-left: 0.5rem;
    color: #999;
    white-space: nowrap;
  }

  .el-input__inner {
    height: 32px;
    border-radius: 16px;
    background: rgba(239, 239, 244, 1);
  }

  .el-input__icon {
    line-height: 32px;
  }

  // input::-webkit-input-placeholder{
  // line-height: 32px !important;
  // }
  input {
    padding: 8px 0.8rem !important;
    height: 30px !important;
    font-size: 14px !important;
    line-height: 14px !important;
  }
}

.panel-content {
  height: calc(100vh - 60px - 59px);
  overflow-y: scroll;

  .panel-scroll {
    height: 100%;
    display: flex;

    .scroll-aside {
      height: 100%;
      overflow: auto;
      flex: 2;

      .aside-item {
        text-align: center;
        // height: 60px;
        padding: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }

      .item-active {
        background: #ffffff !important;
      }
    }

    .scroll-panel {
      flex: 5;
      height: 100%;
      overflow: auto;
      background: #fff;
      .panel-item {
        display: flex;
        height: 71px;
        padding: 0.15rem 0;
        background: #ffffff;
        justify-content: flex-start;
        align-items: center;
        margin-left: 10px;

        .item-radio {
          display: flex;
          align-items: center;
          width: 46px;

          .cube-checkbox {
            padding: 0 0 0 0.16rem;
          }
        }
        .item-phone {
          display: flex;
          align-items: center;
          width: 60px;
          height: 60px;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .item-info {
          flex: 1;
          margin-left: 0.3rem;

          .info-name {
            height: 30px;
            line-height: 30px;
            font-size: 16px;
            font-weight: 400;
            color: rgba(53, 53, 53, 1);
            width:132px;
            overflow: hidden; /* 超出部分隐藏 */
            white-space: nowrap; /* 不换行 */
            text-overflow: ellipsis; /* 超出部分文字以...显示 */
          }

          .info-number {
            height: 20px;
            line-height: 20px;
            color: rgba(153, 153, 153, 1);
            font-size: 14px;
          }
        }
      }
    }
  }
}

.cube-radio-wrap {
  .cube-radio-ui {
    font-size: 22px;
  }
}

.cube-action-sheet-list {
  height: 151px;
  overflow: auto;
  touch-action: auto;
}

.cube-action-sheet-space {
  height: 0.03rem;
}

.cube-action-sheet-title {
  background: rgba(232, 232, 241, 1);
  color: rgba(136, 136, 136, 1);
  height: 0.2rem;
  line-height: 0.2rem;
  font-size: 15px;
}

.management-name {
  display: inline-block;
  font-size: 14px;
  line-height: 18px;
  // text-overflow: ellipsis;
  // white-space: nowrap;
  // overflow: hidden;
}
</style>